import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Description } from './styles';

export const Header: React.FC = () => (
	<Row>
		<Col span={24}>
			<Description>
				<span>{I18n.get('Activity is safe for')}:</span>
			</Description>
		</Col>
	</Row>
);
